import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';
import _ from 'lodash';
import Clipboard from 'clipboard';
import { RenderCheckboxRadioField, RenderSubmitButton } from '../../form';
import { fetchGuestList, editGuestGroup, sendMessageCollectAddress, copyLink } from '../../../../actions/GuestActions';
import { showModal, hideModal } from '../../../../actions/ModalActions'; // eslint-disable-line

import './RequestMissingInfoModal.less';


class RequestMissingInfoModal extends Component {
  constructor(props) {
    super(props);

    this.initializeClipboard = this.initializeClipboard.bind(this);
    this.destroyClipboard = this.destroyClipboard.bind(this);
    this.getPrimaryGuest = this.getPrimaryGuest.bind(this);
    this.formatName = this.formatName.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.addGuestGroupEmail = this.addGuestGroupEmail.bind(this);

    this.state = {
      clipboard: undefined,
      isClipboardSupported: Clipboard.isSupported(),
      clipboardErrorMessage: undefined,
      emailAddress: '',
      isValid: false,
    };
  }

  componentDidMount() {
    this.initializeClipboard();
  }

  componentWillReceiveProps(nextProps) {
    const { guestGroupsWithEmail, updateFormWithEmail } = this.props;
    if (nextProps.guestGroupsWithEmail.length !== guestGroupsWithEmail.length) {
      updateFormWithEmail(nextProps.guestGroupsWithEmail.map(guestGroup => guestGroup.id));
    }
  }

  componentWillUnmount() {
    this.destroyClipboard();
  }

  getPrimaryGuest(guestGroup) {
    return _.find(guestGroup.guests, guest => guest.relationship_type === 'PRIMARY');
  }

  handleChange(e) {
    e.preventDefault();
    const nextValue = e.target.value;
    const emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const isValid = emailReg.test(nextValue);
    this.setState({
      emailAddress: nextValue,
      isValid
    });
  }

  addGuestGroupEmail(e, guestGroup) {
    e.preventDefault();
    const { updateGuestGroup } = this.props;
    const { emailAddress } = this.state;
    updateGuestGroup(Object.assign({}, guestGroup, { email_address: emailAddress }));
  }

  formatName(guestGroup) {
    const guest = this.getPrimaryGuest(guestGroup);
    if (guest.first_name && guest.family_name) {
      return `${guest.first_name} ${guest.family_name}`;
    } else if (guest.first_name) {
      return `${guest.first_name}`;
    } else if (guest.family_name) {
      return `${guest.family_name}`;
    }
    return 'Guest';
  }

  initializeClipboard() {
    const clipboard = new Clipboard('#collect-address-link-modal-copy');

    clipboard.on('success', (e) => {
      const target = e.trigger;
      const currentButtonText = target.innerText;
      target.innerText = 'Copied!';
      target.disabled = true;
      setTimeout(() => {
        target.innerText = currentButtonText;
        target.disabled = false;
      }, 1000);
    });

    clipboard.on('error', () => {
      let clipboardErrorMessage = '';
      if (/iPhone|iPad/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Select and copy.';
      } else if (/Mac/i.test(navigator.userAgent)) {
        clipboardErrorMessage = 'Press ⌘-C to copy.';
      } else {
        clipboardErrorMessage = 'Press Ctrl-C to copy.';
      }
      this.setState({ clipboardErrorMessage });
      setTimeout(() => this.setState({ clipboardErrorMessage: undefined }), 5000);
    });

    this.setState({ clipboard });
  }

  destroyClipboard() {
    const { clipboard } = this.state;
    if (clipboard) clipboard.destroy();
    this.setState({
      clipboard: undefined
    });
  }

  render() {
    const { wedding, weddingAccount, guestGroups, guestGroupsWithEmail, guestGroupsWithoutEmail, handleSubmit, valid, closeModal, fromAddGuestForm, onBack, onCopyLink } = this.props;
    const { emailAddress, isClipboardSupported, clipboardErrorMessage } = this.state;

    const hashId = weddingAccount.hash_id;

    return (
      <div id="request-missing-info-modal">
        <div className="modal-header">
          {guestGroups.length === 1 && fromAddGuestForm && (
            <div onClick={() => onBack(guestGroups[0].id)} className="text-button margin-bottom">&lsaquo; Back</div>
          )}
          <h3 className="modal-title">Request Missing Info</h3>
        </div>
        <div className="modal-body">
          {guestGroups.length === 1 && (
            <div className="modal-body-section by-link">
              <h3 className="modal-section-title">By Link</h3>
              <p className="modal-section-description">
                Text or email this unique link to your guest, they’ll fill out a custom form, and we’ll update your list for you.
              </p>
              <div className="copy-link">
                <div className="copy-link-actions">
                  {isClipboardSupported && (
                    <button id="collect-address-link-modal-copy" onClick={() => onCopyLink(guestGroups[0].id)} className="btn btn-primary btn-left" data-clipboard-text={`${window.location.protocol}//${window.location.host}/addr/${hashId}?ref=${guestGroups[0].uuid}`}>Copy Link</button>
                  )}
                  {clipboardErrorMessage && (
                    <div className="help-block">{clipboardErrorMessage}</div>
                  )}
                  <button className="btn btn-secondary btn-right" onClick={closeModal}>Done</button>
                </div>
                <div className="copy-link-input">{`${window.location.protocol}//${window.location.host}/addr/${hashId}?ref=${guestGroups[0].uuid}`}</div>
              </div>
              <p className="copy-link-label">Want to see what your guest will see? <a href={`/addr/${hashId}?ref=${guestGroups[0].uuid}`} className="text-button" target="_blank" rel="noopener noreferrer">Preview the link &rsaquo;</a></p>
            </div>
          )}
          <div className="modal-body-section">
            <h3 className="modal-section-title by-email">By Email</h3>
            <p className="modal-section-description">
              We’ll send the below note to your {guestGroups.length === 1 ? 'guest' : 'guests'}. They’ll fill out a private form online and we’ll update your list for you.
            </p>
            <div className="missing-emails">
              {(guestGroups.length === 1) && !guestGroups[0].email_address && (
                <div className="add-guest-email">
                  <p className="text-danger">Add <strong>{this.getPrimaryGuest(guestGroups[0]).first_name} {this.getPrimaryGuest(guestGroups[0]).family_name}&#39;s</strong> email address to send them this note.</p>
                  <input
                    type="email"
                    className="form-control guest-email-input"
                    value={emailAddress}
                    onChange={this.handleChange}
                    placeholder="Email Address"
                  />
                  <button disabled={!this.state.isValid} onClick={e => this.addGuestGroupEmail(e, guestGroups[0])} className="btn btn-primary">Save</button>
                </div>
              )}
              {(guestGroups.length > 1) && (guestGroupsWithoutEmail.length > 0) && (
                <p className="text-danger">
                  <strong>{guestGroupsWithoutEmail.map(this.formatName).join(', ')}</strong> {guestGroupsWithoutEmail.length > 1 ? 'require' : 'requires'} an email address to send them this note.
                </p>
              )}
            </div>
            <form onSubmit={handleSubmit} noValidate>
              <div className={`form-horizontal guest-message ${guestGroups.length === 1 && !guestGroups[0].email_address ? 'grayed-out' : ''}`}>
                <div className="form-group">
                  <label htmlFor="guest-group-message-from" className="col-sm-2 control-label">From</label>
                  <div className="col-sm-8">
                    <p id="guest-group-message-from" className="form-control-static">
                      {wedding.owner_first_name} {wedding.owner_last_name} &amp; {wedding.partner_first_name} {wedding.partner_last_name}
                    </p>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="guest-group-message-to" className="col-sm-2 control-label">To / BCC</label>
                  {guestGroups.length === 1 && (
                    <div className="col-sm-8">
                      <p id="guest-group-message-to" className="form-control-static">
                        {guestGroups.map(this.formatName).join(', ')}
                      </p>
                    </div>
                  )}
                  {guestGroups.length > 1 && (
                    <div className="col-sm-8">
                      {guestGroupsWithEmail.length > 0 && (
                        <p id="guest-group-message-to" className="form-control-static">
                          {guestGroupsWithEmail.map(this.formatName).join(', ')}
                        </p>
                      )}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label htmlFor="guest-group-message-subject" className="col-sm-2 control-label">Subject</label>
                  <div className="col-sm-8">
                    <p id="guest-group-message-subject" className="form-control-static">We need your address!</p>
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="guest-group-message-message" className="col-sm-2 control-label">Message</label>
                  <div className="col-sm-9">
                    <p id="guest-group-message-message" className="form-control-static">Hi there,</p>
                    <br />
                    <p>We are deep in wedding planning and noticed that we are missing your address. Could you take the next few moments to provide your info for us?</p>
                    <br />
                    <p>[ENTER ADDRESS]</p>
                    <br />
                    <p>Thanks!<br />{wedding.owner_first_name} &amp; {wedding.partner_first_name}</p>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="form-group">
                  <div className="checkbox">
                    <Field
                      id="guest-message-send-to-self"
                      name="send_to_self"
                      component={RenderCheckboxRadioField}
                      type="checkbox"
                      label="Send a copy to me"
                      styleOverride
                      className={`text-muted ${guestGroups.length === 1 && !guestGroups[0].email_address ? 'disabled' : ''}`}
                      disabled={guestGroups.length === 1 && !guestGroups[0].email_address}
                    />
                  </div>
                </div>
                <RenderSubmitButton pristine={false} valid={valid} value="Send Email" disabled={guestGroupsWithEmail.length === 0} />
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

RequestMissingInfoModal.propTypes = {
  wedding: PropTypes.shape({}),
  weddingAccount: PropTypes.shape({}),
  guestGroups: PropTypes.arrayOf(PropTypes.shape({})),
  guestGroupsWithEmail: PropTypes.arrayOf(PropTypes.shape({})),
  guestGroupsWithoutEmail: PropTypes.arrayOf(PropTypes.shape({})),
  updateGuestGroup: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  closeModal: PropTypes.func,
  updateFormWithEmail: PropTypes.func,
  onBack: PropTypes.func,
  fromAddGuestForm: PropTypes.bool,
  onCopyLink: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => {
  const guestGroups = ownProps.guestGroupIds.map(guestGroupId => state.guestList.guests.byId[guestGroupId]);
  const [guestGroupsWithEmail, guestGroupsWithoutEmail] = _.partition(guestGroups, guest => guest.email_address);

  return {
    initialValues: {
      guest_group_ids: guestGroupsWithEmail.map(guestGroup => guestGroup.id),
      send_to_self: false
    },
    weddingAccount: state.wedding.account,
    wedding: state.wedding.wedding,
    guestGroups,
    guestGroupsWithEmail,
    guestGroupsWithoutEmail,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: collectAddressRequest => dispatch(sendMessageCollectAddress(collectAddressRequest)).then(() => dispatch(hideModal())),
  updateGuestGroup: guestGroup => dispatch(editGuestGroup(guestGroup)).then(() => dispatch(fetchGuestList())),
  updateFormWithEmail: guestGroupsWithEmail => dispatch(change('requestMissingInfoForm', 'guest_group_ids', guestGroupsWithEmail)),
  closeModal: () => dispatch(hideModal()),
  onBack: (guestGroupId) => {
    if (ownProps.callback) ownProps.callback();
    return dispatch(showModal('EDIT_GUEST_GROUP_WEDDING', { guestGroupId, callback: () => dispatch(fetchGuestList()) }));
  },
  onCopyLink: guestGroupId => dispatch(copyLink(guestGroupId))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'requestMissingInfoForm'
})(RequestMissingInfoModal));



// WEBPACK FOOTER //
// ./src/components/common/modals/RequestMissingInfoModal/RequestMissingInfoModal.jsx